import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { guestGuard } from '@core/guards/guest.guard';
import { publicAuthFlowGuard } from '@core/guards/public-auth-flow.guard';
import { AuthStore } from '@core/stores/auth.store';

/** The code step only makes sense right after a password sign-in that asked for 2FA. */
const twoFactorChallengeGuard: CanActivateFn = () =>
  inject(AuthStore).twoFactorChallenge() ? true : inject(Router).createUrlTree(['/login']);

/** Public auth pages, all rendered inside {@link AuthLayout}. Mounted at the app root. */
export const authRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
        title: 'auth:login.title',
      },
      {
        path: 'auth/two-factor',
        canActivate: [guestGuard, twoFactorChallengeGuard],
        loadComponent: () =>
          import('./pages/two-factor/two-factor.page').then((m) => m.TwoFactorPage),
        title: 'auth:twoFactor.title',
      },
      {
        path: 'auth/forgot-password',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./pages/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
        title: 'auth:forgotPassword.title',
      },
      {
        path: 'auth/reset-password',
        canActivate: [publicAuthFlowGuard],
        loadComponent: () =>
          import('./pages/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
        title: 'auth:resetPassword.title',
      },
      {
        path: 'auth/enroll',
        canActivate: [publicAuthFlowGuard],
        loadComponent: () => import('./pages/enroll/enroll.page').then((m) => m.EnrollPage),
        title: 'auth:enroll.title',
      },
    ],
  },
];
